import RequestPage from '../components/photographer/Request'

export default {
  path: '/request-page',
  component: RequestPage,
  meta: {
    title: 'Request page',
    active: false
  }
}
